import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, onToggleCollapse }) => {
  const menuItems = [
    { path: '/', icon: '📊', label: 'Dashboard' },
    { path: '/user-management', icon: '👥', label: 'User Management' },
    { path: '/managers', icon: '👨‍💼', label: 'Managers' },
    { path: '/advertisers', icon: '📢', label: 'Advertisers' },
    { path: '/affiliates', icon: '🤝', label: 'Affiliates' },
    { path: '/offers', icon: '🎯', label: 'Offers' },
    { path: '/billing', icon: '💳', label: 'Billing' },
    { path: '/managers-report', icon: '📋', label: 'Managers Report' },
    { path: '/daily-report', icon: '📅', label: 'Daily Report' },
    { path: '/conversion-report', icon: '🔄', label: 'Conversion Report' },
    { path: '/smartlink-report', icon: '🔗', label: 'Smartlink Report' },
    { path: '/chart-report', icon: '📈', label: 'Chart Report' },
    { path: '/goal-report', icon: '🎯', label: 'Goal Report' },
    { path: '/install-report', icon: '📱', label: 'Install Report' },
    { path: '/settings', icon: '⚙️', label: 'Setting' },
    { path: '/custom-payouts', icon: '💰', label: 'Custom Payouts' },
    { path: '/top-offers', icon: '🏆', label: 'Top Offers' },
    { path: '/activity-log', icon: '📝', label: 'Activity Log' },
    { path: '/system-offers', icon: '🖥️', label: 'System Offers' },
    { path: '/advertiser-integrations', icon: '🔌', label: 'Advertiser Integrations' },
    { path: '/publisher-api', icon: '🔑', label: 'Publisher API' }
  ];

  return (
    <div className={`sidebar ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="sidebar-header">
        <button
          type="button"
          className="sidebar-collapse-btn"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? '›' : '‹'}
        </button>
        <div className="logo">
          <img
            src="/site-logo.jpeg"
            alt="AdBizz Media"
            style={{
              width: isCollapsed ? '92px' : '140px',
              height: 'auto',
              display: 'block',
              margin: '0 auto'
            }}
          />
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            title={isCollapsed ? item.label : undefined}
          >
            <span className="nav-icon">{item.icon}</span>
            {!isCollapsed && <span className="nav-label">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
